import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    jwt: "",
    esAdmin: false
  },
  mutations: {
    anadirStoreAlLocalStorage(state, jwt) {
      state.jwt = jwt.token;
      state.esAdmin = jwt.esAdmin;
      const now = new Date(Date.parse(jwt.expiracion));

      localStorage.setItem("jwt", jwt.token);
      localStorage.setItem("expires", now.toUTCString());
      localStorage.setItem("esAdmin", jwt.esAdmin);
      localStorage.setItem("email", jwt.email);
    },
    anadirLocalStorageAlStore(state) {
      if (
        localStorage.getItem("jwt") !== null &&
        localStorage.getItem("esAdmin") !== null
      ) {
        if (Date.now() < Date.parse(localStorage.getItem("expires") || "")) {
          state.jwt = localStorage.getItem("jwt") || "";
          state.esAdmin = localStorage.getItem("esAdmin") === "true";
        }
      }
    },
    cerrarSesion(state) {
      state.jwt = "";
      state.esAdmin = false;
      localStorage.removeItem("jwt");
      localStorage.removeItem("expires");
      localStorage.removeItem("esAdmin");
      localStorage.removeItem("email");
    }
  }
});
